import cx from 'classnames';
import dynamic from 'next/dynamic';
import React from 'react';
import { scrollTopClasses } from '@/vdp/styles';
import ShowConditionally from '@/vdp/VehicleDetailsContainer/ShowConditionally';
import { LowerSectionsWrapper } from '@/vdp/VehicleDetailsContainer/styles';
import Section, { SectionId } from '~/constants/vdp/section';
import BelowFoldViewHandler from '../Analytics/BelowFoldViewHandler';
import dynamicLoader from '../dynamicLoader';

const AffordableProtection = dynamic(
  () =>
    import(
      /* webpackChunkName: "AffordableProtection" */ '../AffordableProtection'
    ),
  { ssr: false, loading: dynamicLoader(Section.Ancillaries) }
);

const MoneyBackGuarantee = dynamic(
  () =>
    import(
      /* webpackChunkName: "MoneyBackGuarantee" */ '../MoneyBackGuarantee'
    ),
  { ssr: false, loading: dynamicLoader(Section.Inspection) }
);

const Inspection = dynamic(
  () => import(/* webpackChunkName: "Inspection" */ '../Inspection'),
  { ssr: false, loading: dynamicLoader(Section.Inspection) }
);

const OwnerReviews = dynamic(
  () => import(/* webpackChunkName: "OwnerReviews" */ '../OwnerReviews'),
  { ssr: false, loading: dynamicLoader(Section.OwnerReviews) }
);

export type OwnProps = {
  gridRef: React.RefObject<HTMLDivElement | null>;
  shouldLoadBelowFirstSection?: boolean;
  showInitialDivider?: boolean;
  wrapperRef: React.RefObject<HTMLDivElement | null>;
};

export default function ControlLowerSections({
  gridRef,
  shouldLoadBelowFirstSection = true,
  showInitialDivider,
  wrapperRef
}: OwnProps) {
  return (
    <LowerSectionsWrapper>
      <ShowConditionally ownerReviews>
        {showInitialDivider && (
          <div className="border-b border-border-weak sm:ml-2xl md:mx-0" />
        )}
        <BelowFoldViewHandler
          id={SectionId.OwnerReviews}
          data-nav-section={SectionId.OwnerReviews}
          className={cx(SectionId.OwnerReviews, scrollTopClasses, {
            'will-load': !shouldLoadBelowFirstSection
          })}
        >
          <ShowConditionally renderBelowFirstSection>
            <OwnerReviews gridRef={gridRef} wrapperRef={wrapperRef} />
          </ShowConditionally>
        </BelowFoldViewHandler>
      </ShowConditionally>
      <BelowFoldViewHandler
        id={SectionId.Inspection}
        data-nav-section={SectionId.Inspection}
        className={cx(SectionId.Inspection, scrollTopClasses, {
          'will-load': !shouldLoadBelowFirstSection
        })}
      >
        <ShowConditionally renderBelowFirstSection>
          <Inspection gridRef={gridRef} wrapperRef={wrapperRef} />
        </ShowConditionally>
      </BelowFoldViewHandler>
      <BelowFoldViewHandler
        id={SectionId.MoneyBackGuarantee}
        className={cx(SectionId.MoneyBackGuarantee, {
          'will-load': !shouldLoadBelowFirstSection
        })}
      >
        <ShowConditionally renderBelowFirstSection>
          <MoneyBackGuarantee />
        </ShowConditionally>
      </BelowFoldViewHandler>
      <div className="border-b border-border-weak sm:ml-2xl md:mx-0" />
      <BelowFoldViewHandler
        id={SectionId.Ancillaries}
        className={cx(SectionId.Ancillaries, {
          'will-load': !shouldLoadBelowFirstSection
        })}
      >
        <ShowConditionally renderBelowFirstSection>
          <AffordableProtection gridRef={gridRef} wrapperRef={wrapperRef} />
        </ShowConditionally>
      </BelowFoldViewHandler>
    </LowerSectionsWrapper>
  );
}
